export default __webpack_public_path__ + "static/media/TaraAndersen.0988ecb8.jpg";